import produce from "immer";
import AuthService from '../AuthService';
import { EVO } from '../EVO';
import { urls } from "../urls";
import { defaultChore } from "../defaultValues";

const GET_CHORES = 'peptalkr/Chores/GET_CHORES';
const GET_CHORES_SUCCESS = 'peptalkr/Chores/GET_CHORES_SUCCESS';
const GET_CHORES_FAILURE = 'peptalkr/Chores/GET_CHORES_FAILURE';
const GET_CHORE_SUCCESS = 'peptalkr/Chores/GET_CHORE_SUCCESS';

const ADD_CHORE = 'peptalkr/Chore/ADD_CHORE';
const ADD_CHORE_SUCCESS = 'peptalkr/Chore/ADD_CHORE_SUCCESS';
const ADD_CHORE_FAILURE = 'peptalkr/Chore/ADD_CHORE_FAILURE';

export const requestChores = () => ({ type: GET_CHORES });
export const receiveChores = (chores, id, allTags) => ({ type: GET_CHORES_SUCCESS, chores, id, allTags });
export const receiveChoresFail = error => ({ type: GET_CHORES_FAILURE, error });
export const receiveChore = (chore) => ({ type: GET_CHORE_SUCCESS, chore });

export const addChore = () => ({ type: ADD_CHORE });
export const addChoreSuccess = chore => ({ type: ADD_CHORE_SUCCESS, chore });
export const addChoreFailure = error => ({ type: ADD_CHORE_FAILURE, error });

export const fetchchores = (props) => (dispatch) => {
    const id = EVO.getParamsId(props);
    if (id && id === 'new') {
        dispatch(receiveChore(defaultChore))
    }
    else if (props && props.chores) {
        dispatch(receiveChores(props.chores, id))
    }
    else {
        const authService = new AuthService();
        if (authService.isAuthenticated()) {
            dispatch(requestChores());
            EVO.fetch(urls.api.chores.getAll)
                .then(response => {
                    dispatch(receiveChores(response.chores, id, response.allTags));
                })
                .catch(error => dispatch(receiveChoresFail(error)));
        }
    }
};

export const addOrUpdateItem = (item) => (dispatch) => {
    if (AuthService.getInstance().isAuthenticated()) {
        dispatch(addChore());
        return EVO.fetch(item.id ? urls.api.chores.update : urls.api.chores.add, item)
            .then(response => dispatch(addChoreSuccess(response)))
            .catch(error => dispatch(addChoreFailure(error)));
    }
};

const initialState = {
    chores: null,
    chore: defaultChore,
    loading: true,
    allTags: [],
    error: false
};

export default produce((draft, action) => {
    switch (action.type) {
        case GET_CHORES:
            draft.loading = true;
            return;
        case GET_CHORES_SUCCESS:
            draft.loading = false;
            draft.chores = action.chores;
            draft.allTags = action.allTags || [];
            draft.chore = action.id ? EVO.getDetailsItemById(action.chores, action.id, defaultChore) : defaultChore;
            draft.chore.startTimeOffsetNeg = -draft.chore.startTimeOffset;
            return;
        case GET_CHORES_FAILURE:
            draft.loading = false;
            draft.error = action.error;
            return;
        case GET_CHORE_SUCCESS:
            draft.loading = false;
            draft.chore = action.chore;
            return;
        case ADD_CHORE:
            // nothing to do.. Formik handles it
            return;
        case ADD_CHORE_SUCCESS:
            draft.chore = Object.assign(EVO.clone(defaultChore), action.chore);
            return;
        case ADD_CHORE_FAILURE:
            draft.error = action.error;
            return;
        default: return;
    }
}, initialState)


// WEBPACK FOOTER //
// ./src/redux/chores.js